import { FC, lazy, useEffect, useLayoutEffect } from 'react';
import { isMobile } from 'react-device-detect';

import Helmet from '@/components/meta/Helmet';

const GuideRaceCardPcTemplate = lazy(
  () => import('@/components/templates/Guide/RaceCard/pc'),
);
const GuideRaceCardSpTemplate = lazy(
  () => import('@/components/templates/Guide/RaceCard/sp'),
);

import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';

import { GuidePageTitles } from '../types';

const GuideRaceCardPage: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useEffect(() => {
    setBreadcrumbs([
      {
        name: 'ご利用ガイド',
        to: '/guide',
      },
      {
        name: '出走表の見方',
        to: '',
      },
    ]);
  }, []);

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  return (
    <>
      <Helmet
        meta={{
          title: GuidePageTitles.RaceCard,
          description:
            'DMM競輪のご利用ガイドページ。出走表の見方についてご案内します。',
          keywords: `${GuidePageTitles.RaceCard},ご利用ガイド,%s`,
        }}
      />
      {isMobile ? <GuideRaceCardSpTemplate /> : <GuideRaceCardPcTemplate />}
    </>
  );
};

export default GuideRaceCardPage;
